import { Link } from 'react-router-dom';
import { useI18n } from 'core/i18n/I18nProvider';
import { paths } from 'core/routing/paths';
import { ErrorIllustration } from 'shared/assets/illustrations';
import { PageMeta } from 'shared/components/PageMeta';

export function NotFoundPage() {
  const { t } = useI18n();
  return (
    <div className="state-page error-state">
      <PageMeta titleKey="errors.notFound" />
      <ErrorIllustration />
      <p className="code-display">404</p>
      <h1>{t('notFound.title')}</h1>
      <p>{t('notFound.body')}</p>
      <Link className="btn btn-primary" to={paths.welcome}>{t('notFound.home')}</Link>
    </div>
  );
}
